// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\np[data-v-1e4788a0] {\r\n  text-indent: 2em;\r\n  line-height: 25px;\n}\r\n", ""]);
// Exports
module.exports = exports;
